import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollReportDTO  {
    _originalTypeClassName = "zERP.BO.PayrollReportDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollReportDTO.translate = translateService;
}
this.Period = null;
this.Type = null;
this.Registry = null;
this.RegistryNumber = null;
this.AM = null;
this.Lastname = null;
this.Firstname = null;
this.Grossamount = null;
this.Daysinsured = null;
this.EmployeeContribution = null;
this.EmployerContribution = null;
this.TotalContribution = null;
this.Insuredincome = null;
this.AMA = null;
this.PayrollReportDTOKey = null;
this._key = this.PayrollReportDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Period:any;
Type:any;
Registry:any;
RegistryNumber:any;
AM:any;
Lastname:any;
Firstname:any;
Grossamount:any;
Daysinsured:any;
EmployeeContribution:any;
EmployerContribution:any;
TotalContribution:any;
Insuredincome:any;
AMA:any;
private _PayrollReportDTOKey:any;
get PayrollReportDTOKey(): any {
    return this._PayrollReportDTOKey;
  }
set PayrollReportDTOKey(value: any) {
    this._PayrollReportDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollReportDTOKey == null || $this.PayrollReportDTOKey == 0;
            }


}